import { httpClient } from "src/shared/services/httpClient";

export const getBusinessMenu = () => {
  return httpClient.get("business/businessMenuParams");
};
